import { ChangeDetectorRef, Component, ElementRef, Input, ViewChild } from "@angular/core";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { take } from "rxjs/operators";

import { ItemCategory } from "src/app/frontoffice/catalog/model/item-category.model";
import { PortalService } from "../../portal.service";

@Component({
  selector: "app-item-categories-select",
  templateUrl: "./item-categories-select.component.html",
  styleUrls: ["./item-categories-select.component.scss"],
})
export class ItemCategoriesSelectComponent extends BaseFormComponent<any> {
  @Input() itemCategory: ItemCategory;
  @ViewChild("mainImageElement") mainImageElement: ElementRef;
  images: string[] = [];
  selectedImage;

  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef, private ps: PortalService) {
    super(selectorService, cd);
  }

  async ngOnInit() {
    this.getImages();
  }

  public select(i: any): void {
    this.selectedImage = i;
  }

  public onSubmit(): void {
    const data = { imageIndex: this.selectedImage, itemCategoryId: this.itemCategory.Id };
    this.httpCommonService
      .create("Peripheral/ItemCategoriesImage", data)
      .pipe(take(1))
      .subscribe((response: any) => {
        if (response) {
          this.sts.showToast("success", "", this.translate("ClientApp.FrontOffice.Portal.ItemCategoriesImage.ImagesChangedSuccessfully"), 3000);
          this.ps.itemCategoryImages[this.itemCategory.Id] = response[0] + "?" + Math.random().toString();
          this.close();
        }
      });
  }

  private getImages(): void {
    this.httpCommonService
      .get("Peripheral/ItemCategoriesImage")
      .pipe(take(1))
      .subscribe((data: any) => {
        this.images = data;
      });
  }
}
